import { Plus } from "@/components/Plus";
import { AudienceList } from "@/features/audiences/AudienceList";
import { SurveyList } from "@/features/surveys/SurveyList";
import { TemplateSurveys } from "@/features/surveys/templates/TemplateSurveys";
import { storageService } from "@/services/StorageService";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function WorkspacePage() {
  const [surveys, setSurveys] = useState<any[]>([]);
  const [audiences, setAudiences] = useState<any[]>([]);
  useEffect(() => {
    storageService.getAllSurveys().then((surveys) => {
      console.info("Got Surveys", surveys);
      setSurveys(surveys);
    });
    storageService.getAllAudiences().then((audiences) => {
      console.info("Got Audiences", audiences);
      setAudiences(audiences);
    });
  }, []);

  return (
    <div className="flex flex-col gap-4 px-8">
      <h2 className="text-2xl">Survey Templates</h2>
      <TemplateSurveys />
      <h2 className="text-2xl">Surveys</h2>
      <SurveyList surveys={surveys} />
      <div>
        <Link to="/newsurvey">
          <button className="btn-primary">
            <Plus /> Create Survey
          </button>
        </Link>
      </div>
      {/* <hr className="" />
      <h2 className="text-2xl font-semibold">Audiences</h2>
      <AudienceList audiences={audiences} />
      <div>
        <Link to="/newaudience">
          <button className="btn-primary">
            <Plus /> Create Audience
          </button>
        </Link>
      </div> */}
    </div>
  );
}
